export enum PhaseStatus {
  RUNNING = 'running',
  COMPLETED = 'completed',
  ERROR = 'error',
}

export enum OutputType {
  TEXT_MESSAGE = 'text_message',
  CODE_BLOCK = 'code_block',
  PLOT_IMAGE = 'plot_image',
  FILE_REFERENCE = 'file_reference',
  MARKDOWN_TEXT = 'markdown_text',
  ERROR_MESSAGE = 'error_message',
  DATA_SUMMARY_TABLE = 'DATA_SUMMARY_TABLE',
}

export interface PhaseOutput {
  id: string
  output_type: OutputType
  data: any
  description?: string
  file_path?: string
  metadata?: Record<string, any>
  created_at: string
}

export interface ReasoningPhase {
  phase_id: string
  title: string
  goal?: string
  status: PhaseStatus
  started_at: string
  ended_at?: string
  conclusion?: string
  outputs: PhaseOutput[]
  reasoning_steps: string[]
}

export interface FileReference {
  file_id: string
  filename: string
  path: string
  public_url: string
  file_type?: string
  size: number
  description?: string
  created_at: string
}

export interface WorkspaceFile {
  name: string
  url: string
}

export interface ReasoningTrace {
  session_id: string
  conversation_id: string
  title: string
  started_at: string
  ended_at?: string
  duration?: number
  status: 'running' | 'completed' | 'error'
  working_directory: string
  phases: ReasoningPhase[]
  files: FileReference[]
  workspace_files?: WorkspaceFile[]
  metadata: Record<string, any>
  datasources?: DatasourceReference[]
  summary?: {
    total_phases: number
    completed_phases: number
    error_phases: number
    total_files: number
    total_outputs: number
  }
}

export interface DatasourceReference {
  datasource_id: string
  name: string
  type: string
  usage_count?: number
}

export interface ReasoningTracesListResponse {
  traces: ReasoningTrace[]
  total: number
  page: number
  limit: number
  hasMore: boolean
}

export interface ReasoningTraceFilters {
  status?: 'running' | 'completed' | 'error'
  startDate?: string
  endDate?: string
  search?: string
  conversationId?: string
}

export interface Conversation {
  conversation_id: string
  name: string
  type: 'DM' | 'GROUP'
  participants: string[]
  last_activity: string
  trace_count: number
  metadata?: Record<string, any>
}

export interface ConversationsListResponse {
  conversations: Conversation[]
  total: number
}
